import React from "react";

import { removeBeforeloadEvent } from "../../../Utility/utility";
import { SalesContext } from "./../../../Context/SalesContext";

import "./Error.css";

class Error extends React.Component {
    static contextType = SalesContext;

    componentDidMount() {
        removeBeforeloadEvent();
    }

    onBtnClick = () => {
        this.context.setErrorObject(null);
        window.location.href = "/vodacom/fibre/sales/leads";
    }

    render() {
        return (
            <div className="error__container alert-page error-page">
                <div className="section-icon success-icon" automationid={`SalesLead_Div_ErrorIcon_0`}>
                    <svg focusable="false" aria-hidden="true" className="icon">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-exclamation"></use>
                    </svg>
                </div>
                <div className="error__heading" automationid={`SalesLead_Div_OopsHeading_0`}>Oops...</div>
                <div className="error__description" automationid={`SalesLead_Div_ErroDescription_0`}>
                    {this.context.errorObject ?
                        <div automationid="SalesLead_Div_ErroDescription_110">{this.context.errorObject.message}</div>
                        :
                        <React.Fragment>
                            <div automationid="SalesLead_Div_ErroDescription_111">A technical glitch has prevented us from submitting your details.</div>
                            <div automationid="SalesLead_Div_ErroDescription_112">Please contact our Customer Care on <strong>082 1904</strong></div>
                        </React.Fragment>
                    }
                </div>
                <div className="error__btn">
                    <button
                        automationid={`SalesLead_Button_OkButton_0`}
                        onClick={this.onBtnClick}
                    >OK</button>
                </div>
            </div>
        )
    }
}

export default Error;